if(!customElements.get('latest-news')) {
  customElements.define(
    'latest-news',
    class LatestNews extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) return console.error("Unable to initialize latest news without a slider.");

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            }
          },
          navigation: {
            prevEl: '.slider-button.latest-news-slider-button.prev',
            nextEl: '.slider-button.latest-news-slider-button.next',
          },
          pagination: {
            el: '.slider-pagination.latest-news-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}